import { takeLatest, put, call } from 'redux-saga/effects';
import { featureFlagsRetrievalFailed, setFeatureFlags } from './featureFlagsActions';
import { ActionTypes, FeatureFlags, IFeatureFlagsGetAction } from './constants';
import { retrieveFeatureFlags } from './service';

function* callRetrieveFeatureFlags(action: IFeatureFlagsGetAction) {
  try {
    const featureFlagValues: FeatureFlags = yield call(retrieveFeatureFlags, action.payload);

    yield put(setFeatureFlags(featureFlagValues));
  } catch (e) {
    yield put(featureFlagsRetrievalFailed());
  }
}

export function* watchFeatureFlags() {
  yield takeLatest(ActionTypes.FEATURE_FLAGS_INIT, callRetrieveFeatureFlags);
}
